import type { BreadcrumbTrailItem } from './entities';

export const BENZINGA_BREADCRUMB_ORIGIN = 'https://www.benzinga.com';

const toAbsoluteBenzingaUrl = (urlOrPath: string): string => {
  try {
    const parsed = new URL(urlOrPath, BENZINGA_BREADCRUMB_ORIGIN);
    return `${BENZINGA_BREADCRUMB_ORIGIN}${parsed.pathname}${parsed.search}`;
  } catch {
    return BENZINGA_BREADCRUMB_ORIGIN;
  }
};

export const buildBreadcrumbListNode = (items: BreadcrumbTrailItem[]) => ({
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => {
    const url = toAbsoluteBenzingaUrl(item.url);
    return {
      '@type': 'ListItem',
      item: {
        '@id': url,
        '@type': 'WebPage',
        name: item.name,
        url,
      },
      position: index + 1,
    };
  }),
});

export const buildBreadcrumbList = (items: BreadcrumbTrailItem[]) => ({
  '@context': 'https://schema.org/',
  ...buildBreadcrumbListNode(items),
});

export const isRenderableBreadcrumbTrail = (
  items: BreadcrumbTrailItem[] | null | undefined,
): items is BreadcrumbTrailItem[] =>
  Array.isArray(items) && items.length >= 2 && items.every(item => !!item?.name && !!item?.url);
